import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVComponent } from './simple-icons-v.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVComponent ],
    exports:      [ SimpleIconsVComponent ],
    bootstrap:    []
})
export class SimpleIconsVModule {}
